<template>
  <FormGroup
    v-model="referralSource"
    type="ajax-select"
    label-method="name"
    label="Referral source"
    :disabled="disabled"
    :fetch-options="fetchOptions"
    :on-select="onSelect"
  />
</template>

<script setup>
import clientApi from '@/js/Api/Client';
import settingsApi from '@/js/Api/Settings';
import FormGroup from '@/js/Common/Form/FormGroup/FormGroup.vue';
import useClientStore from '@/js/store/pinia/useClientStore';

const props = defineProps({
  clientId: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: true,
  },
});

const clientStore = useClientStore();
const { ref: referralSource } = clientStore.swrReferralSource({ id: props.clientId });

const fetchOptions = (query, page) => {
  return settingsApi.referralSources.index({
    queryBuilder: {
      page,
      filters: {
        search: query,
      },
    },
  });
};

const onSelect = (option) => {
  return clientApi.referralSource.update({
    id: props.clientId,
    data: {
      id: option ? option.id : null,
      model_type: option ? option.model_type : null,
    },
  });
};
</script>
